
<div class="telemetry-make-responsive">
    <div *ngFor="let attr of masterAttributeList">
        <div class="telemetry-box">
            <div class="attr-name">{{attr?.attributeName ?? attr?.name}}</div>
            <div *ngIf="attr?.attributeName !== 'Ignition Status'">{{attr?.attributeValue ? attr?.attributeValue.toFixed(3) : '0'}} {{attr?.attributeValue ? (attr?.uom ?? '') : ''}}</div>
            <div *ngIf="attr?.attributeName === 'Ignition Status'">{{attr?.attributeValue ? (attr?.attributeValue === 0 ? 'OFF' : 'ON') : 'OFF'}} {{attr?.attributeValue ? (attr?.uom ?? '') : ''}}</div>
        </div>
    </div>
</div>
